"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContentTraverser_1 = require("../contentTraverser/ContentTraverser");
/**
 * get block element's text content.
 * @param rootNode Root node that the get the textContent of.
 * @returns text content of given text content.
 */
function getTextContent(rootNode) {
    var traverser = ContentTraverser_1.default.createBodyTraverser(rootNode);
    var block = traverser && traverser.currentBlockElement;
    var textContent = [];
    while (block) {
        textContent.push(block.getTextContent());
        block = traverser.getNextBlockElement();
    }
    return textContent.join('\n');
}
exports.default = getTextContent;
//# sourceMappingURL=getTextContent.js.map